const ZH_TW = Object.freeze({
  'travel.me.hub.canonicalLabel': '我的內容',
  'travel.me.hub.accountLabel': '帳號與行程工具',
  'travel.me.hub.profileHint': '查看你的旅人頁面與公開內容',
  'travel.me.hub.editProfileHint': '修改暱稱與頭像',
  'travel.me.vip.title': 'VIP',
  'travel.me.vip.unavailableHint': '專屬 VIP 頁面尚未開通；VIP 權益仍會在揪團等既有畫面顯示。',
  'travel.me.settings.title': '設定',
  'travel.me.settings.privacy': '隱私權政策',
  'travel.me.settings.agreement': '服務條款',
  'travel.me.settings.blocked': '封鎖名單',
});

const EN_US = Object.freeze({
  'travel.me.hub.canonicalLabel': 'My content',
  'travel.me.hub.accountLabel': 'Account & trip tools',
  'travel.me.hub.profileHint': 'Open your creator page and public content',
  'travel.me.hub.editProfileHint': 'Update nickname and avatar',
  'travel.me.vip.title': 'VIP',
  'travel.me.vip.unavailableHint': 'A dedicated VIP page is not available yet. VIP benefits still appear in existing Group Trip surfaces.',
  'travel.me.settings.title': 'Settings',
  'travel.me.settings.privacy': 'Privacy policy',
  'travel.me.settings.agreement': 'Terms of service',
  'travel.me.settings.blocked': 'Blocked accounts',
});

const ZH_CN = Object.freeze({
  'travel.me.hub.canonicalLabel': '我的内容',
  'travel.me.hub.accountLabel': '账号与行程工具',
  'travel.me.hub.profileHint': '查看你的旅人页面与公开内容',
  'travel.me.hub.editProfileHint': '修改昵称与头像',
  'travel.me.vip.title': 'VIP',
  'travel.me.vip.unavailableHint': '专属 VIP 页面尚未开通；VIP 权益仍会在跟团等既有画面显示。',
  'travel.me.settings.title': '设置',
  'travel.me.settings.privacy': '隐私权政策',
  'travel.me.settings.agreement': '服务条款',
  'travel.me.settings.blocked': '封锁名单',
});

const BY_LOCALE = Object.freeze({
  zh_TW: ZH_TW,
  en_US: EN_US,
  zh_CN: ZH_CN,
});

export function getMeHubMessage(locale, key) {
  const table = BY_LOCALE[locale] || ZH_TW;
  return table[key] || key;
}
